import React, { Component } from 'react';

class ConfirmadorBaja extends Component {
    render() {
        debugger
        const { data, actions, cuenta } = this.props;
        let mensaje = "Confirma la baja de la cuenta prepaga Nro. " + cuenta.CuentaTarjetaNumero + " de " + cuenta.Nombre + "?";

        return (
            <div className='modaConfirmadorInterior'>
                <div>{mensaje}</div>

                <div className='footerTelefonosModal'>
                    <button onClick={() => actions.cancelar()} className='btn btn-secondary'>Cancelar</button>
                    <button onClick={() => actions.DarBajaCuentaTarjeta(cuenta)} className='btn btn-cta'>Aceptar</button>
                </div>
            </div>
        );
    }
}
export default ConfirmadorBaja;